import { useContext } from "react";
import { DarkModeContext } from "././context/darkModeContext";
import Navigation from "./navigation";
import BottomSheet from './components/BottomSheet';
import { BottomSheetProvider } from './components/BottomSheetContext';

function App() {
  // Extract darkMode from the DarkModeContext
  const { darkMode } = useContext(DarkModeContext);

  return (
    // Apply dark mode class conditionally to the app container
    <div className={darkMode ? "app dark" : "app"}>
      <BottomSheetProvider>
        <Navigation />
        {/* Assuming BottomSheet is used somewhere in your app */}
        <BottomSheet />
      </BottomSheetProvider>
    </div>
  );
}

export default App;
